var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}},{key:"item.dateRecommended",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("dateFormat")(item.dateRecommended)))]}},{key:"item.attachment",fn:function(ref){
var item = ref.item;
return [_vm._t("attachment",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }